import styled from 'styled-components';

const shouldForwardProp = (prop) => !['align', 'direction', 'gap', 'wrap'].includes(prop);

export const Wrapper = styled('div').withConfig({ shouldForwardProp })`
  flex-shrink: 0;
  display: flex;
  flex-direction: ${(props) => props.direction};
  flex-wrap: ${(props) => (props.wrap ? 'wrap' : 'nowrap')};
  ${(props) =>
    props.direction === 'row' || props.direction === 'row-reverse'
      ? 'justify-content'
      : 'align-items'}: ${(props) => props.align};
  gap: ${(props) => props.gap}px;
`;
